const COMPONENT_NAME = "sync-height";
const CLASS_SELECTOR = ".SyncHeight";

const instances = [];
let initialized = false;

function syncAll() {
    for (const instance of instances) {
        if (instance && instance.sync) {
            instance.sync();
        }
    }
}

function initialize(element, PageComponents) {
    if (!initialized) {
        window.addEventListener('resize', syncAll);
        initialized = true;
    }
    const syncTargets = element.dataset.sync === "target";
    function sync() {
        let height = 0;
        let targets;
        const targetSelector = element.dataset.target;
        if (targetSelector) {
            targets = element.querySelectorAll(targetSelector);
        } else {
            targets = element.children;
        }
        if (targets) {

            for(const target of targets) {
                if (syncTargets) {
                    target.style.height = null;
                }
                height = Math.max(height, target.offsetHeight);
            }

            if(syncTargets) {
                for(const target of targets) {
                    target.style.height = height + 'px';
                }
            } else {
                element.style.height = height + 'px';
            }
        }
    }
    sync();
    instances.push({
        element,
        sync
    });
}

module.exports = {
    name: COMPONENT_NAME,
    instances,
    initialize
};
